class InitiateMandate {
  authorizationId: number;
  requestId: string;
  authenticationMethod: string;
  authorizationDurationSeconds: number;
  authorizationExpiresAt: string;

  constructor(
    authorizationId: number,
    requestId: string,
    authenticationMethod: string,
    authorizationDurationSeconds: number,
    authorizationExpiresAt: string,
  ) {
    this.authorizationId = authorizationId;
    this.requestId = requestId;
    this.authenticationMethod = authenticationMethod;
    this.authorizationDurationSeconds = authorizationDurationSeconds;
    this.authorizationExpiresAt = authorizationExpiresAt;
  }
}

export default InitiateMandate;
